import { Page } from '@common/paged-data/types/page.type';

export function createEmptyPage<T>(): Page<T> {
  return {
    AllPagesLoaded: true,
    Items: [],
    Page: 0,
    PropertyNameErrors: null,
    Total: 0
  };
}
